export type ThemeEventTarget = {
  addEventListener: (event: string, listener: EventListener) => void;
  removeEventListener: (event: string, listener: EventListener) => void;
};

export const attachSystemThemeListener = (
  target: ThemeEventTarget,
  listener: EventListener
): (() => void) => {
  /* action-id: lifecycle.theme.system */ target.addEventListener(
    "change",
    listener
  );
  return () => target.removeEventListener("change", listener);
};
